import React, { useState } from 'react';
function TeamDetails({ team, handleSaveTeamDetails }) {
  const [newTeamName, setNewTeamName] = useState(team ? team.name : '');

  // Handle saving the payment URLs after the team name is already set
  const handleSubmit = () => {
      handleSaveTeamDetails({"name": newTeamName});
  };

  return (
    <div>
      {/* If teamName is missing, ask for team name */}
      {
        <div>
          <h2 className="font-lustra text-3xl text-white text-center mb-6">
            ¡Denle un Nombre a su Leyenda Galáctica!
          </h2>
          <div className="mt-4">
            <div className="mt-2 mb-2 text-lg space-y-4 text-white">
              <p>
                En una galaxia llena de caos y pagos interdimensionales, un nombre lo es todo. No solo será la
                bandera que ondeará en el Scoreboard, también será el grito de guerra que resonará en cada esquina
                del cosmos... o al menos en este juego.
              </p>
              <p>
                Piensen en su nombre como la tarjeta de presentación de su equipo ante la galaxia. Podrían optar
                por algo elegante y memorable, como <b>"Los Señores del Hiperespacio"</b>, o algo más honesto,
                como <b>"Esperemos que Esto Funcione"</b>. Solo recuerden:
              </p>
              <p>
                <div>
                  <ul className="list-disc pl-8 space-y-2">
                    <li className="text-gray-200">Los nombres creativos serán recordados.</li>
                    <li className="text-gray-200">Los nombres aburridos serán ignorados.</li>
                    <li className="text-gray-200">Los nombres demasiado largos... probablemente
                      se corten y/o nos rompan el formato de la presentación en el juego.
                    </li>
                  </ul>
                </div>
              </p>
              <p>
                Así que pónganse creativos porque este nombre no solo definirá su equipo, sino también la
                cantidad de risas o admiración que genere.
              </p>
              <p>
                Elijan sabiamente y que las fuerzas del cosmos los acompañe. 🚀
              </p>
            </div>

            <div className="mt-2 mb-2 text-lg space-y-4 text-white">
              <div className="mt-4 border-t border-gray-100">
                <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                  <div className="sm:col-span-6">
                    <label htmlFor="team_name" className="block text-lg font-bold leading-6 text-white">
                      Nombre del Equipo
                    </label>
                    <div className="mt-2">
                      <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-full">
                        <input
                          id="team_name"
                          name="team_name"
                          type="text"
                          value={newTeamName}
                          onChange={(e) => setNewTeamName(e.target.value)}
                          className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-white placeholder:text-gray-400 focus:ring-0 sm:text-base sm:leading-6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6 flex items-center gap-x-6 justify-end">
                <button
                  onClick={handleSubmit}
                  className="rounded-md bg-blue-700 px-3 py-2 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Guardar!
                </button>
              </div>
            </div>

          </div>
        </div>
      }
    </div>
  );
}

export default TeamDetails;
